module.exports = __webpack_public_path__ + "img/D201603_3.fe633c0f.jpg";